import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';

const categories = [
  { id: 'teknik', label: 'Teknik sorun' },
  { id: 'gorusme', label: 'Görüşme problemi' },
  { id: 'etik', label: 'Etik dışı davranış' },
  { id: 'rahatsiz', label: 'Rahatsız edici konuşma' },
  { id: 'yanlis', label: 'Yanlış bilgi' },
  { id: 'guven', label: 'Güven problemi' },
  { id: 'diger', label: 'Diğer' },
];

const conversations = [
  { id: 1, label: 'Boutique Spa - İstanbul (#1)' },
  { id: 2, label: 'Resort Spa - Antalya (#2)' },
  { id: 3, label: 'Wellness Club - İzmir (#3)' },
];

export default function DestekPage() {
  const [category, setCategory] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [relatedConversation, setRelatedConversation] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!category || !subject || !message) return;
    setSubmitted(true);
  };

  return (
    <PanelLayout>
      <div className="max-w-2xl mx-auto">
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-2">Destek & Şikayet</h1>
        <p className="text-sm text-gray-500 mb-6">
          Bir sorun yaşadınız veya şikayetiniz mi var? Destek ekibimize ulaşın. Tüm bildirimler gizli kalır ve incelenir.
        </p>

        {!submitted ? (
          <div className="bg-white rounded-xl border border-gray-100 p-5 space-y-5">
            {/* Category */}
            <div>
              <label className="block text-sm font-medium text-deep-navy-500 mb-2">Kategori *</label>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setCategory(cat.id)}
                    className={`px-3 py-2 rounded-lg text-xs font-medium border transition-colors text-left cursor-pointer ${
                      category === cat.id
                        ? 'bg-dark-teal-50 border-dark-teal-200 text-dark-teal-600'
                        : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'
                    }`}
                  >
                    {cat.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Subject */}
            <div>
              <label className="block text-sm font-medium text-deep-navy-500 mb-2">Konu *</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500"
                placeholder="Kısaca konuyu özetleyin..."
              />
            </div>

            {/* Related Conversation */}
            <div>
              <label className="block text-sm font-medium text-deep-navy-500 mb-2">İlgili Görüşme</label>
              <select
                value={relatedConversation}
                onChange={(e) => setRelatedConversation(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500 bg-white"
              >
                <option value="">Görüşme seçin (opsiyonel)</option>
                {conversations.map((conv) => (
                  <option key={conv.id} value={String(conv.id)}>
                    {conv.label}
                  </option>
                ))}
              </select>
              <p className="text-[10px] text-gray-400 mt-1">İlgili görüşme seçilirse destek ekibi daha hızlı inceleme yapabilir.</p>
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-deep-navy-500 mb-2">Açıklama *</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={6}
                maxLength={500}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500 resize-none"
                placeholder="Sorununuzu veya şikayetinizi detaylı açıklayın..."
              />
              <p className="text-[10px] text-gray-400 mt-1 text-right">{message.length}/500</p>
            </div>

            <button
              onClick={handleSubmit}
              className="px-6 py-2.5 rounded-lg bg-dark-teal-500 text-white text-sm font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer"
            >
              Gönder
            </button>
          </div>
        ) : (
          <div className="bg-white rounded-xl border border-gray-100 p-8 text-center">
            <span className="w-12 h-12 flex items-center justify-center mx-auto rounded-full bg-green-50 text-green-600 mb-3">
              <i className="ri-check-line text-2xl" />
            </span>
            <h3 className="text-lg font-semibold text-deep-navy-500 mb-2">Bildiriminiz incelendi ve gerekli işlem yapılmıştır.</h3>
            <p className="text-sm text-gray-500">
              Destek ekibimiz en kısa sürede size dönüş sağlayacaktır.
            </p>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}